import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Box } from "@mui/system"

export const sharedStyle = {
  marginRight: 10
}
export const StyledTypography = styled(Typography)(sharedStyle)
export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(sharedStyle)
export const sharedEmailBoxStyle = {
  borderRadius: "10px"
}
export const StyledEmailBox = styled(Box)(sharedEmailBoxStyle)
export const StyledPrimaryTypography = styled(StyledTypography)(({ theme }) => ({
  color: theme.palette.grey[900]
}))
export const StyledSuccessTypograpy = styled(StyledTypography)(({ theme }) => ({
  color: theme.palette.success["main"]
}))
export const StyledErrorTypography = styled(StyledTypography)(({ theme }) => ({
  color: theme.palette.error["main"]
}))
export const StyledPrimaryFontAwesomeIcon = styled(StyledFontAwesomeIcon)(({ theme }) => ({
  color: (theme.palette as any).primary["700"]
}))
export const StyledSuccessFontAwesomeIcon = styled(StyledFontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.success["main"]
}))
export const StyledErrorFontAwesomeIcon = styled(StyledFontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.error["main"]
}))
export const StyledSendFontAwesomeIcon = styled(FontAwesomeIcon)({
  fontSize: "14px !important"
})
